module.exports = __webpack_public_path__ + "img/kaa.33e959c9.svg";